import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Separator } from "../Components/ui/separator.tsx";
import Navbar from "../Components/Analytics/Navbar.tsx";
import Settings from "../Components/Analytics/Settings.tsx";
import { v4 as uuidv4 } from "uuid";
import { useQuery } from "@tanstack/react-query";
import { useApi } from "../Api/useApi.ts";
import { useFormInsightsContext } from "../Contexts/FormInsightsContext.tsx";

const FixedFields = [
    {
        id: uuidv4(),
        title: "Date",
        type: "date",
        checked: true,
    },
    {
        id: uuidv4(),
        title: "State",
        type: "status",
        checked: true,
        selectedChoices: [],
        multiChecked: false,
        choices: [
            { id: uuidv4(), label: "started" },
            { id: uuidv4(), label: "completed" },
            { id: uuidv4(), label: "partial" },
        ],
    },
];

const FormAnalyticsLayout = ({ children }) => {
    const api = useApi();
    const { urlId } = useParams();
    const { workspaceId } = useParams();
    const { setForm, setFields } = useFormInsightsContext();
    const { data: formResponse } = useQuery({
        queryKey: ["form", urlId],
        queryFn: () =>
            api.revisions.getOneRevision(
                urlId as string,
                workspaceId as string,
            ),
        staleTime: Infinity,
        retry: 1,
    });

    useEffect(() => {
        const form = formResponse?.data?.form ?? {};
        setForm(form);

        const rawFields = form?.fields;

        if (!Array.isArray(rawFields)) {
            setFields([]); // fallback
            return;
        }

        const formattedFields = rawFields.flatMap((field) => {
            if (field?.properties?.fields) {
                return field?.properties?.fields.map((nestedField: any) => ({
                    id: nestedField.id,
                    title: nestedField.title,
                    type: nestedField.type,
                    checked: true,
                    selectedChoices: [],
                    multiChecked: false,
                }));
            } else {
                return [
                    {
                        id: field.id,
                        title: field.title,
                        type: field.type,
                        choices: field?.properties?.choices,
                        checked: true,
                        selectedChoices: [],
                        multiChecked: false,
                    },
                ];
            }
        });

        formattedFields.unshift(...FixedFields);
        setFields(formattedFields);
    }, [formResponse?.data]);

    return (
        <div className="relative flex flex-col h-screen px-4 text-left no-scrollbar">
            <Navbar
                formId={formResponse?.data?.form?._id}
                formTitle={formResponse?.data?.form?.title}
            />
            <Separator className="absolute left-0 w-full px-0 top-10 md:top-14" />
            <div className="max-w-[1440px] w-full mx-auto">
                <Settings />
                {children}
            </div>
        </div>
    );
};

export default FormAnalyticsLayout;
